export const isOnSSR = (): boolean => (typeof process !== 'undefined' && (process?.env?.IS_SSR as unknown)) as boolean;
